import React from 'react'

function ViewRTO({ rtoData }) {
  const details = rtoData?.Details || []
  return (
    <>
      <div className="row">
        <div className="col-md-6 mb-3">
          <label className="form-label">Sales #</label>
          <input type="text" className="form-control" value={rtoData?.SalesNumber || ''} disabled />
        </div>
        <div className="col-md-6 mb-3">
          <label className="form-label">Customer Name</label>
          <input type="text" className="form-control" value={rtoData?.CustomerName || ''} disabled />
        </div>
        <div className="col-md-6 mb-3">
          <label className="form-label">Mobile</label>
          <input type="text" className="form-control" value={rtoData?.MobileNumber || ''} disabled />
        </div>
        <div className="col-md-6 mb-3">
          <label className="form-label">Payment Mode</label>
          <input type="text" className="form-control" value={rtoData?.PaymentMode || ''} disabled />
        </div>
        <div className="col-md-6 mb-3">
          <label className="form-label">Status</label>
          <input type="text" className="form-control" value={rtoData?.Status || ''} disabled />
        </div>
        <div className="col-md-6 mb-3">
          <label className="form-label">Vehicle Registration Number</label>
          <input type="text" className="form-control" value={rtoData?.VehicleRegistrationNumber || ''} disabled />
        </div>
        <div className="col-12 mb-3">
          <label className="form-label">Remark</label>
          <textarea className="form-control" rows="3" value={rtoData?.Remark || ''} disabled />
        </div>
      </div>

      <div className="table-responsive">
        <table className="table table-sm mb-0">
          <thead>
            <tr>
              <th>Vehicle</th>
              <th>Payment</th>
              <th>Chassis</th>
              <th>Engine</th>
            </tr>
          </thead>
          <tbody>
            {details.length ? details.map((d) => (
              <tr key={d?.SalesRegisterDetailId}>
                <td>{d?.VehicleLabel || '-'}</td>
                <td>{d?.PaymentType || '-'}</td>
                <td>{d?.ChassisNo || '-'}</td>
                <td>{d?.EngineNo || '-'}</td>
              </tr>
            )) : (
              <tr>
                <td colSpan="4" className="text-muted">No vehicle details</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  )
}

export default ViewRTO